var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, Button, Collapse } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
const useStyles = makeStyles(theme => ({
    item: {
        display: 'block',
        paddingTop: 0,
        paddingBottom: 0
    },
    itemLeaf: {
        display: 'flex',
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%'
    },
    buttonLeaf: {
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
        fontWeight: theme.typography.fontWeightRegular,
        '&.depth-0': {
            fontWeight: theme.typography.fontWeightMedium
        }
    },
    icon: {
        color: theme.palette.icon,
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(1)
    },
    expandIcon: {
        marginLeft: 'auto',
        height: 16,
        width: 16
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto'
    },
    active: {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium,
        '& $icon': {
            color: theme.palette.primary.main
        }
    }
}));
export function NavItem(_a) {
    var { title, href, depth, children, icon: Icon, className, open: openProp, label: Label } = _a, rest = __rest(_a, ["title", "href", "depth", "children", "icon", "className", "open", "label"]);
    const classes = useStyles();
    const [open, setOpen] = useState(openProp);
    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };
    let paddingLeft = 8;
    if (depth > 0) {
        paddingLeft = 32 + 8 * depth;
    }
    const style = {
        paddingLeft
    };
    if (children) {
        return (React.createElement(ListItem, Object.assign({}, rest, { className: clsx(classes.item, className), disableGutters: true, key: title }),
            React.createElement(Button, { className: classes.button, onClick: handleToggle, style: style },
                Icon && React.createElement(Icon, { className: classes.icon }),
                title,
                open ? (React.createElement(ExpandLessIcon, { className: classes.expandIcon, color: "inherit" })) : (React.createElement(ExpandMoreIcon, { className: classes.expandIcon, color: "inherit" }))),
            React.createElement(Collapse, { in: open }, children)));
    }
    return (React.createElement(ListItem, Object.assign({}, rest, { className: clsx(classes.itemLeaf, className), disableGutters: true, key: title }),
        React.createElement(Button, { activeClassName: classes.active, className: clsx(classes.buttonLeaf, `depth-${depth}`), component: RouterLink, exact: true, style: style, to: href },
            Icon && React.createElement(Icon, { className: classes.icon }),
            title,
            Label && (React.createElement("span", { className: classes.label },
                React.createElement(Label, null))))));
}
NavItem.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    depth: PropTypes.number.isRequired,
    href: PropTypes.string,
    icon: PropTypes.any,
    label: PropTypes.any,
    open: PropTypes.bool,
    title: PropTypes.string.isRequired
};
NavItem.defaultProps = {
    open: false
};
//# sourceMappingURL=NavItem.js.map